module.exports = __webpack_public_path__ + "img/RDA_tipo2_6pax_78m2.499088bc.png";